import {requestCreate, requestDelete, requestUpdate} from "../api"
import {
    RESET_FORM,
    RESET_STATE,
    SET_FORM
} from "../constant-types"
import { defaultAddToOptionMutation, defaultLoadOptionAction, defaultRemoveFromOptionMutation, defaultSetOptionMutation, defaultUpdateInOptionMutation } from "../default-method"
import {
    updateField,
    getField
} from "vuex-map-fields";

const getDefaultState = () => {
    return {
        options: [],
        option_url: 'category/option',
        form : getDefaultFormState()
    }
}

const getDefaultFormState = () => {
    return {
        id : '',
        related_table : '',
        name : '',
        account_id: null,
        category_class_id: null 
    }
}

export default ({
    namespaced: true, //
    // variable
    state: getDefaultState(),
    // must syncronous
    mutations: {
        [RESET_STATE](state) {
            // Merge rather than replace so we don't lose observers
            // https://github.com/vuejs/vuex/issues/1118
            Object.assign(state, getDefaultState())
        },
        ...defaultSetOptionMutation,
        ...defaultUpdateInOptionMutation,
        ...defaultAddToOptionMutation,
        ...defaultRemoveFromOptionMutation,
        [RESET_FORM](state, relatedTable) {
            state.form = getDefaultFormState()
            state.form.related_table = relatedTable
        },
        [SET_FORM](state, payload) {
            Object.assign(state.form, {
                id : payload.id,
                related_table: payload.related_table,
                name: payload.name,
                account_id: payload.account ? payload.account.id : null,
                category_class_id: payload.category_class_id,
            })
        },
        updateField
    },
    // can async
    actions: {
        ...defaultLoadOptionAction,
        requestCreateCategory({commit, state}) {
            requestCreate('category', state.form, commit, 'ADD_TO_OPTION')
        },
        requestUpdateCategory({commit, state}) {
            requestUpdate(`category/${state.form.id}`, state.form, commit, 'UPDATE_IN_OPTION')
        },
        requestDeleteCategory({commit, state}, category) {
            requestDelete(`category/${category.id}`, {}, commit, category.name, 'REMOVE_FROM_OPTION')
        }
    },
    // call variable with custom display
    getters: {
        optionByRelatedTable: (state) => relatedTable => state.options.filter(o => o.related_table === relatedTable),
        categoryNameById: state => categoryId => 
            state.options.length > 0 ? state.options.find(o => o.id === +categoryId ).name
            : '---',
        getField
    },
    // modules
    modules: {

    }
})
